import queryString from 'query-string';
import ICampaignID from '../../types/ICampaignID';
import ICampaignInfoContainer from '../../types/ICampaignInfoContainer';

// Class to work with query string as a campaing UUID container
export default class CampaignInfoReferrerContainer implements ICampaignInfoContainer {
  readonly containerName = 'referrer';
  readonly parameterName = 'campaign';

  //list of search engines regular expressions including subdomains and regional variations
  readonly searchEngines = [
    /(^|\.)google\./i,
    /(^|\.)bing\./i,
    /(^|\.)yahoo\./i,
    /(^|\.)baidu\./i,
    /(^|\.)yandex\./i,
    /(^|\.)duckduckgo\./i,
    /(^|\.)aol\./i,
    /(^|\.)ask\./i,
    /(^|\.)naver\./i,
    /(^|\.)seznam\./i,
    /(^|\.)ecosia\./i,
    /(^|\.)qwant\./i,
    /(^|\.)yandex\./i,
    /(^|\.)sogou\./i,
    /(^|\.)360\./i,
    /(^|\.)youdao\./i,
    /(^|\.)so\.com/i,
    /(^|\.)daum\./i,
  ];

  referredFromSearchEngine() {
    const paramValue = queryString.parse(location.search)[this.parameterName];
    if (paramValue) return false;
    const referrer = document.referrer;
    if (!referrer) return false;
    // Extract hostname from referrer URL
    let hostname = '';
    try {
      hostname = new URL(referrer).hostname;
    } catch (e) {
      // fallback: try to parse manually
      hostname = referrer.split('/')[2] || '';
    }
    // Check if the hostname matches a search engine
    return this.searchEngines.some((regex) => regex.test(hostname));
  }

  load() {
    if (!this.referredFromSearchEngine()) return null;
    //search engine with no campaign parameter is always merchandising
    const result: ICampaignID = {
      UUID: 'merchandising',
      container: this.containerName,
    };
    return result;
  }

  store(campaignId: ICampaignID) {
    return !!campaignId;
  }
}
